var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5537 2.95186L12.9232 3.35696L13.2926 2.95186C14.5177 1.60848 16.2057 0.851562 17.9866 0.851562C21.5433 0.851562 24.4713 3.8691 24.4713 7.61944C24.4713 9.29686 23.8213 10.9566 22.5575 12.4207C20.3848 14.9376 13.7359 21.899 12.9232 22.7487C12.1108 21.8993 5.46148 14.9376 3.28884 12.4208C2.02506 10.9566 1.375 9.29687 1.375 7.61944C1.375 3.8691 4.30301 0.851562 7.85972 0.851562C9.64061 0.851562 11.3286 1.60848 12.5537 2.95186Z",
    stroke: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.50a6eba04ba17e6dc7e4af77b19e6944.svg";
export { ForwardRef as ReactComponent };